// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"231":"8973d850124854d7","554":"cf8be4378240cec3","944":"c7fcc6d1ba10be68"}[chunkId] + ".js";
};